var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Los saludos","audio2":"../mp3/PrimariaA/02PA.mp3","cover":"../img/1.jpg","name":"Primaria A - Lección #2"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }